import { render } from "./GuestNavbar.vue?vue&type=template&id=b4da2922&scoped=true"
import script from "./GuestNavbar.vue?vue&type=script&lang=js"
export * from "./GuestNavbar.vue?vue&type=script&lang=js"

import "./GuestNavbar.vue?vue&type=style&index=0&id=b4da2922&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4da2922"]])

export default __exports__